<section class="event-view-page">
  <a class="back-link" [routerLink]="ticketAddMode && event ? ['/dashboard/tickets', event.slug || event.id] : ticketsMode ? '/dashboard/tickets' : '/dashboard/events'">
    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>
    <span>{{ ticketAddMode ? 'К таблице билетов' : ticketsMode ? 'К билетам' : 'К событиям' }}</span>
  </a>

  <div class="message success" *ngIf="successMessage">{{ successMessage }}</div>
  <div class="message error" *ngIf="errorMessage">{{ errorMessage }}</div>
  <div class="loading-card" *ngIf="loading">Загрузка события...</div>

  <ng-container *ngIf="event && !loading">
    <section class="match-card">
      <div class="team-side">
        <span class="team-logo" [style.background-image]="getLogoBackground(event.homeTeam)">{{ event.homeTeam.logoUrl ? '' : event.homeTeam.name.charAt(0) }}</span>
        <strong>{{ event.homeTeam.name }}</strong>
      </div>
      <div class="match-center">
        <span>{{ formatDate(event.startsAt) }}</span>
        <h1>{{ event.homeTeam.name }} - {{ event.awayTeam.name }}</h1>
        <p>{{ getSeasonName(event) }}</p>
        <strong class="event-status" [class.work]="event.status === 'in_progress'" [class.done]="event.status === 'completed'">{{ getEventStatusName(event.status) }}</strong>
        <div class="match-actions" *ngIf="!ticketsMode">
          <a
            class="match-action-button"
            *ngIf="canOpenTickets"
            [routerLink]="['/dashboard/tickets', event.slug || event.id]"
            title="Открыть билеты"
            aria-label="Открыть билеты">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 9V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v4"/><path d="M3 15v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-4"/><path d="M3 9h18v6H3z"/><path d="M8 12h.01"/></svg>
          </a>
          <a
            class="match-action-button"
            [routerLink]="['/dashboard/events', event.slug || event.id, 'edit']"
            title="Редактировать"
            aria-label="Редактировать событие">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>
          </a>
          <button
            class="match-action-button danger"
            type="button"
            title="Удалить"
            aria-label="Удалить событие"
            (click)="deleteEvent()">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M19 6l-1 14H6L5 6"/></svg>
          </button>
        </div>
      </div>
      <div class="team-side">
        <span class="team-logo" [style.background-image]="getLogoBackground(event.awayTeam)">{{ event.awayTeam.logoUrl ? '' : event.awayTeam.name.charAt(0) }}</span>
        <strong>{{ event.awayTeam.name }}</strong>
      </div>
    </section>

    <section class="metrics-grid">
      <article class="metric-card"><span>Общая сумма закупки</span><strong>{{ formatMoney(event.summary.purchaseTotal) }}</strong></article>
      <article class="metric-card"><span>Расходы</span><strong>{{ formatMoney(event.summary.expenseTotal) }}</strong></article>
      <article class="metric-card"><span>Планируемая прибыль</span><strong>{{ formatMoney(event.summary.plannedProfitAfterExpenses) }}</strong></article>
      <article class="metric-card"><span>Всего билетов</span><strong>{{ event.summary.ticketsTotal }}</strong></article>
      <article class="metric-card"><span>Продано</span><strong>{{ soldTicketsCount }}</strong></article>
      <article class="metric-card"><span>Осталось продать</span><strong>{{ remainingTicketsCount }}</strong></article>
      <article class="metric-card"><span>ROI</span><strong>{{ formatRoi(event) }}</strong></article>
    </section>

    <section class="event-analytics-grid">
      <article class="break-even-card" [class.reached]="isBreakEvenReached">
        <div class="analytics-heading">
          <div>
            <span>Окупаемость события</span>
            <h2>{{ breakEvenStatusText }}</h2>
          </div>
          <strong>{{ formatNumber(breakEvenProgressPercent) }}%</strong>
        </div>
        <div class="break-even-track" aria-label="Прогресс выхода в ноль">
          <span class="break-even-fill" [style.width]="breakEvenProgressStyle"></span>
        </div>
        <div class="break-even-values">
          <span>Выручка продаж <strong>{{ formatMoney(soldRevenueTotal) }}</strong></span>
          <span>Точка нуля <strong>{{ formatMoney(breakEvenTarget) }}</strong></span>
        </div>
      </article>

      <article class="sales-helper-card" [class.success]="salesInsight.tone === 'success'" [class.warning]="salesInsight.tone === 'warning'" [class.danger]="salesInsight.tone === 'danger'">
        <div class="analytics-heading">
          <div>
            <span>Помощник продаж</span>
            <h2>{{ salesInsight.title }}</h2>
          </div>
          <strong>{{ daysUntilEvent }} дн.</strong>
        </div>
        <p>{{ salesInsight.description }}</p>
        <div class="helper-stats">
          <span>Средний темп <strong>{{ formatTicketsPerDay(averageSoldPerDay) }}</strong></span>
          <span>Нужно продавать <strong>{{ formatTicketsPerDay(requiredSalesPerDay) }}</strong></span>
        </div>
      </article>
    </section>

    <section class="expenses-panel" *ngIf="!ticketsMode">
      <div class="panel-heading compact">
        <div>
          <h2>Расходы события</h2>
          <span>Прямые расходы и доля месячных расходов для этого матча.</span>
        </div>
        <a class="action-button ghost" routerLink="/dashboard/expenses">Расходы</a>
      </div>

      <div class="expenses-summary">
        <span>Прямые: <strong>{{ formatMoney(event.summary.directExpenseTotal) }}</strong></span>
        <span>Месячные: <strong>{{ formatMoney(event.summary.monthlyExpenseTotal) }}</strong></span>
        <span>Всего: <strong>{{ formatMoney(event.summary.expenseTotal) }}</strong></span>
      </div>

      <div class="expenses-table-wrap" *ngIf="event.expenses.length > 0; else emptyEventExpenses">
        <table class="expenses-table">
          <thead>
            <tr>
              <th>Расход</th>
              <th>Тип</th>
              <th>Сумма</th>
              <th>Доля события</th>
              <th>Ответственный</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let expense of event.expenses; trackBy: trackById">
              <td>
                <strong>{{ expense.title }}</strong>
                <small *ngIf="expense.comment">{{ expense.comment }}</small>
              </td>
              <td>{{ getExpenseScopeName(expense.scope) }}</td>
              <td>{{ formatMoney(expense.amount) }}</td>
              <td>
                <strong>{{ formatMoney(expense.allocatedAmount) }}</strong>
                <small *ngIf="expense.scope === 'monthly'">делится на {{ expense.eventsInMonth }} событий</small>
              </td>
              <td>{{ expense.createdByUser?.displayName || expense.createdByUser?.username || 'Неизвестно' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <ng-template #emptyEventExpenses>
        <div class="empty-state">Расходы для события пока не добавлены.</div>
      </ng-template>
    </section>

    <section class="tickets-panel" *ngIf="ticketsMode && canOpenTickets && !ticketAddMode">
      <div class="panel-heading">
        <div>
          <h2>Билеты</h2>
          <span>Сектор, ряд, место, цены, плательщик закупки и текущий статус.</span>
        </div>
        <div class="panel-actions">
          <a class="action-button panel-add-button" [routerLink]="['/dashboard/tickets', event.slug || event.id, 'add']">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14"/><path d="M5 12h14"/></svg>
            <span>Добавить</span>
          </a>
        </div>
      </div>

      <ng-container *ngIf="event.tickets.length > 0; else emptyTickets">
        <section class="seat-map-panel prominent">
          <div class="seat-map-heading">
            <div>
              <h3>Сводка по местам</h3>
              <span>Связки считаются только по билетам со статусом «В наличии».</span>
            </div>
            <div class="seat-map-legend">
              <span class="legend-dot available"></span><span>В наличии</span>
              <span class="legend-dot reserved"></span><span>Резерв</span>
            </div>
          </div>

          <div class="sector-seat-grid" *ngIf="ticketSeatGroups.length > 0; else emptySeatMap">
            <article class="sector-seat-card" *ngFor="let sectorGroup of ticketSeatGroups; trackBy: trackBySector">
              <h4>Сектор {{ sectorGroup.sector }}</h4>
              <div class="sector-seat-rows">
                <div class="seat-row-card" *ngFor="let rowGroup of sectorGroup.rows; trackBy: trackByRow">
                  <div class="seat-row-heading">
                    <strong>Ряд {{ rowGroup.row }}</strong>
                    <span>{{ rowGroup.seats.length }} билетов</span>
                  </div>
                  <div class="seat-chip-list">
                    <span
                      class="seat-chip"
                      *ngFor="let seat of rowGroup.seats; trackBy: trackById"
                      [class.available]="seat.status === 'available'"
                      [class.reserved]="seat.status === 'reserved'"
                      [class.sold]="seat.status === 'sold'"
                      [class.gap-before]="seat.startsNewGroup"
                      [title]="getTicketStatusName(seat.status) + ', закупка ' + formatMoney(seat.purchasePrice) + ', продажа ' + formatMoney(seat.salePrice)">
                      {{ seat.seat }}
                    </span>
                  </div>
                  <div class="seat-runs" *ngIf="rowGroup.availableRuns.length > 0; else noAvailableRuns">
                    <span>Связки:</span>
                    <strong *ngFor="let run of rowGroup.availableRuns; trackBy: trackBySeatRun">
                      {{ run.label }} <small>{{ run.count }}</small>
                    </strong>
                  </div>
                  <ng-template #noAvailableRuns>
                    <div class="seat-runs muted">Нет доступных связок</div>
                  </ng-template>
                </div>
              </div>
            </article>
          </div>
          <ng-template #emptySeatMap>
            <div class="empty-state compact">В сводке нет мест со статусом «В наличии» или «Резерв».</div>
          </ng-template>
        </section>

        <div class="tickets-table-wrap">
          <section class="ticket-price-toolbar">
            <div class="ticket-price-copy">
              <strong>Цены продажи</strong>
              <span>Выберите билеты, если нужно проставить одинаковую цену группе.</span>
            </div>
            <div class="ticket-price-actions">
              <span class="selected-count">Выбрано: {{ selectedTicketsCount }}</span>
              <input class="form-control price-bulk-input" type="number" min="0" name="bulkSalePrice" placeholder="Цена продажи" [(ngModel)]="bulkSalePrice">
              <button class="action-button primary" type="button" [disabled]="applyingBulkSalePrice || selectedTicketsCount === 0 || bulkSalePrice === null" (click)="applyBulkSalePrice()">
                {{ applyingBulkSalePrice ? 'Сохраняем...' : 'Проставить выбранным' }}
              </button>
            </div>
          </section>

          <table class="tickets-table">
            <thead>
              <tr>
                <th class="select-column">
                  <input type="checkbox" aria-label="Выбрать все билеты" [checked]="allTicketsSelected" (change)="toggleAllTickets($any($event.target).checked)">
                </th>
                <th><button type="button" (click)="setTicketSort('code')" [attr.aria-sort]="ticketSortState('code')">Билет <span>{{ ticketSortMark('code') }}</span></button></th>
                <th>Файл</th>
                <th><button type="button" (click)="setTicketSort('sector')" [attr.aria-sort]="ticketSortState('sector')">Сектор <span>{{ ticketSortMark('sector') }}</span></button></th>
                <th><button type="button" (click)="setTicketSort('row')" [attr.aria-sort]="ticketSortState('row')">Ряд <span>{{ ticketSortMark('row') }}</span></button></th>
                <th><button type="button" (click)="setTicketSort('seat')" [attr.aria-sort]="ticketSortState('seat')">Место <span>{{ ticketSortMark('seat') }}</span></button></th>
                <th><button type="button" (click)="setTicketSort('purchase')" [attr.aria-sort]="ticketSortState('purchase')">Закупка <span>{{ ticketSortMark('purchase') }}</span></button></th>
                <th><button type="button" (click)="setTicketSort('sale')" [attr.aria-sort]="ticketSortState('sale')">Продажа <span>{{ ticketSortMark('sale') }}</span></button></th>
                <th><button type="button" (click)="setTicketSort('payer')" [attr.aria-sort]="ticketSortState('payer')">Оплатил <span>{{ ticketSortMark('payer') }}</span></button></th>
                <th><button type="button" (click)="setTicketSort('status')" [attr.aria-sort]="ticketSortState('status')">Статус <span>{{ ticketSortMark('status') }}</span></button></th>
                <th>Правка</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let ticket of sortedTickets; trackBy: trackById">
                <td class="select-column">
                  <input
                    type="checkbox"
                    [attr.aria-label]="'Выбрать билет ' + ticket.code"
                    [checked]="isTicketSelected(ticket.id)"
                    [disabled]="!canEditTicketSalePrice(ticket)"
                    (change)="toggleTicketSelection(ticket.id, $any($event.target).checked)">
                </td>
                <td><strong>{{ ticket.code }}</strong></td>
                <td>
                  <div class="ticket-file-cell">
                    <span
                      class="ticket-file-indicator"
                      [class.ready]="ticket.storageFileStatus === 'ready'"
                      [class.mismatch]="ticket.storageFileStatus === 'mismatch'"
                      [class.missing]="!ticket.storageFileStatus || ticket.storageFileStatus === 'missing'"
                      [title]="getTicketStorageFileTitle(ticket)"
                      [attr.aria-label]="getTicketStorageFileTitle(ticket)">
                      <span></span>
                      <small>{{ ticket.storageFilesCount || 0 }}</small>
                    </span>
                    <button
                      class="icon-button file-download-button"
                      type="button"
                      *ngIf="canDownloadTicket(ticket)"
                      [disabled]="downloadingTicketFiles[ticket.id]"
                      [title]="'Скачать билет ' + ticket.code"
                      [attr.aria-label]="'Скачать билет ' + ticket.code"
                      (click)="downloadTicketFile(ticket)">
                      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3v12"/><path d="m7 10 5 5 5-5"/><path d="M5 21h14"/></svg>
                    </button>
                  </div>
                </td>
                <td>{{ ticket.sector }}</td>
                <td>{{ ticket.row }}</td>
                <td>{{ ticket.seat }}</td>
                <td>
                  <input
                    class="price-inline-input"
                    type="number"
                    min="0"
                    [name]="'purchasePrice-' + ticket.id"
                    title="Цена закупки билета"
                    [(ngModel)]="ticketPriceDrafts[ticket.id].purchasePrice">
                </td>
                <td>
                  <input
                    class="price-inline-input"
                    type="number"
                    min="0"
                    [name]="'salePrice-' + ticket.id"
                    [disabled]="!canEditTicketSalePrice(ticket)"
                    [title]="ticket.soldOrderId ? 'Фактическая цена продажи из оплаченного заказа.' : 'Цена продажи билета'"
                    [(ngModel)]="ticketPriceDrafts[ticket.id].salePrice">
                </td>
                <td>
                  <select class="payer-select" [name]="'purchasePaidByUserId-' + ticket.id" [(ngModel)]="ticketPriceDrafts[ticket.id].purchasePaidByUserId">
                    <option [ngValue]="null">Не указан</option>
                    <option *ngIf="ticket.purchasePaidByUserId && !isEventParticipant(ticket.purchasePaidByUserId)" [ngValue]="ticket.purchasePaidByUserId">{{ getPurchasePayerName(ticket.purchasePaidByUserId) }}</option>
                    <option *ngFor="let participant of event.participants; trackBy: trackByUserId" [ngValue]="participant.userId">{{ getParticipantName(participant) }}</option>
                  </select>
                </td>
                <td>
                  <select
                    class="status-select"
                    [class.available]="ticket.status === 'available'"
                    [class.reserved]="ticket.status === 'reserved'"
                    [class.sold]="ticket.status === 'sold'"
                    [disabled]="!canEditTicketStatus(ticket)"
                    [title]="getTicketStatusControlTitle(ticket)"
                    [ngModel]="ticket.status"
                    (ngModelChange)="updateTicketStatus(ticket.id, $event)">
                    <option value="available">В наличии</option>
                    <option value="reserved">Резерв</option>
                    <option value="sold">Выкуплен</option>
                  </select>
                </td>
                <td>
                  <button class="action-button compact" type="button" [disabled]="savingTicketPrices[ticket.id] || !isTicketPriceChanged(ticket)" (click)="saveTicketPrices(ticket)">
                    {{ savingTicketPrices[ticket.id] ? '...' : 'Сохранить' }}
                  </button>
                </td>
                <td><button class="icon-button danger" type="button" title="Удалить" aria-label="Удалить" (click)="deleteTicket(ticket.id)">x</button></td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>

      <ng-template #emptyTickets>
        <div class="empty-state">
          <span>Билеты пока не добавлены.</span>
        </div>
      </ng-template>
    </section>

    <section class="tickets-panel ticket-add-panel" *ngIf="ticketsMode && canOpenTickets && ticketAddMode">
      <div class="panel-heading">
        <div>
          <h2>Добавление билетов</h2>
          <span>Закупка, цена продажи и ответственный участник взаиморасчетов.</span>
        </div>
        <a class="action-button ghost" [routerLink]="['/dashboard/tickets', event.slug || event.id]">Таблица билетов</a>
      </div>

      <section class="ticket-storage-card">
        <div class="storage-heading">
          <div>
            <h3>Хранилище билетов</h3>
            <span>{{ eventStoragePath }}</span>
          </div>
          <strong>{{ event.storageBucketName || 'Не настроено' }}</strong>
        </div>
        <div class="storage-grid">
          <article><span>В наличии</span><strong>{{ event.storagePrefix ? event.storagePrefix + '/available/' : 'Не настроено' }}</strong></article>
          <article><span>Резерв</span><strong>{{ event.storagePrefix ? event.storagePrefix + '/reserved/' : 'Не настроено' }}</strong></article>
          <article><span>Выкуплено</span><strong>{{ event.storagePrefix ? event.storagePrefix + '/sold/' : 'Не настроено' }}</strong></article>
        </div>
      </section>

      <div class="ticket-add-grid">
        <form class="ticket-form ticket-form-card" (ngSubmit)="addTicket()">
          <div class="form-section-heading">
            <h3>Один билет</h3>
            <span>Код в формате Сектор-Ряд-Место.</span>
          </div>
          <label class="form-field">
            <span>Билет</span>
            <input class="form-control" name="code" placeholder="A103-10-12" [(ngModel)]="ticketForm.code">
          </label>
          <label class="form-field">
            <span>Цена закупки</span>
            <input class="form-control" type="number" min="0" name="purchasePrice" [(ngModel)]="ticketForm.purchasePrice">
          </label>
          <label class="form-field">
            <span>Цена продажи</span>
            <input class="form-control" type="number" min="0" name="salePrice" [(ngModel)]="ticketForm.salePrice">
          </label>
          <label class="form-field">
            <span>Оплатил закупку</span>
            <select class="form-select" name="ticketPurchasePaidByUserId" [(ngModel)]="ticketForm.purchasePaidByUserId">
              <option [ngValue]="null">Не указан</option>
              <option *ngFor="let participant of event.participants; trackBy: trackByUserId" [ngValue]="participant.userId">{{ getParticipantName(participant) }}</option>
            </select>
          </label>
          <label class="form-field">
            <span>Статус</span>
            <select class="form-select" name="status" [(ngModel)]="ticketForm.status">
              <option value="available">В наличии</option>
              <option value="reserved">Резерв</option>
              <option value="sold">Выкуплен</option>
            </select>
          </label>
          <button class="action-button primary" type="submit" [disabled]="savingTicket">{{ savingTicket ? 'Добавляем...' : 'Добавить билет' }}</button>
        </form>

        <section class="bulk-ticket-card ticket-add-card">
          <div class="bulk-ticket-heading">
            <div>
              <h3>Массовое добавление</h3>
              <span>Цена продажи будет 0, ее можно заполнить позже.</span>
            </div>
          </div>
          <label class="form-field">
            <span>Оплатил закупку</span>
            <select class="form-select" name="bulkPurchasePaidByUserId" [(ngModel)]="bulkPurchasePaidByUserId">
              <option [ngValue]="null">Не указан</option>
              <option *ngFor="let participant of event.participants; trackBy: trackByUserId" [ngValue]="participant.userId">{{ getParticipantName(participant) }}</option>
            </select>
          </label>
          <textarea
            class="bulk-ticket-input"
            name="bulkTicketsText"
            rows="10"
            aria-label="Список билетов"
            placeholder="Сектор 3 Ряд 21 Место 7 - Цена 12000 Р&#10;3-21-8-12000"
            [(ngModel)]="bulkTicketsText"></textarea>
          <div class="bulk-ticket-actions">
            <button class="action-button primary" type="button" [disabled]="bulkAddingTickets || !bulkTicketsText.trim()" (click)="addBulkTickets()">
              {{ bulkAddingTickets ? 'Добавляем...' : 'Добавить списком' }}
            </button>
          </div>
        </section>
      </div>
    </section>

    <section class="tickets-panel blocked-tickets-panel" *ngIf="ticketsMode && !canOpenTickets">
      <div class="panel-heading">
        <div>
          <h2>Билеты недоступны</h2>
          <span>Билеты можно добавлять только после перевода события в статус «В работе».</span>
        </div>
        <a class="action-button ghost" [routerLink]="['/dashboard/events', event.slug || event.id, 'edit']">Изменить статус</a>
      </div>
    </section>
  </ng-container>
</section>
